import React from "react";
import { Link } from "react-router-dom";
import { FiMapPin, FiPhone, FiMail, FiInfo } from "react-icons/fi";

export default function ShopFooter() {
  return (
    <footer className="mt-8 border-t border-gray-200 bg-[#1E3A5F] text-white">
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {/* About */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-4 shadow-sm sm:p-5">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#FFC107] text-[#1E3A5F]">
                <FiInfo className="h-5 w-5"/>
              </span>
              <h3 className="text-base font-semibold text-white">درباره ما</h3>
            </div>

            <p className="text-sm leading-7 text-white/80 text-justify">
              بازارگاه کالای ساختمانی با تکیه بر پژوهش و تجربه در زنجیره تأمین، برای ساده‌تر، سریع‌تر و مطمئن‌تر شدن
              تأمین کالا ایجاد شده است. ما با گردآوری تأمین‌کنندگان منتخب و تسهیل فرآیند خرید، حمل و تحویل، تجربه‌ای
              شفاف‌تر برای صنعت ساختمان فراهم می‌کنیم.
            </p>


            <Link
                to="/about-us"
                className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-[#FFC107] transition-colors hover:text-[#D19D00]"
            >
              درباره ما
              <span aria-hidden="true">←</span>
            </Link>
          </div>

          {/* Contact */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-4 shadow-sm sm:p-5">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#00AFA9] text-white">
                <FiPhone className="h-5 w-5" />
              </span>
              <h3 className="text-base font-semibold text-white">تماس با ما</h3>
            </div>

            <div className="space-y-3 text-sm text-white/80">
              <div className="flex items-start gap-2">
                <FiMapPin className="mt-1 h-4 w-4 shrink-0 text-[#FFC107] text-justify" />
                <p className="leading-7">
                  همدان، کیلومتر 5 جاده کرمانشاه، روبه روی کارخانه آرد مریانج، فروشگاه کالای ساختمانی سازین.
                </p>
              </div>

              <div className="flex items-center gap-2">
                <FiPhone className="h-4 w-4 shrink-0 text-[#FFC107]" />
                <a
                  href="tel:02112345678"
                  className="transition-colors hover:text-[#FFC107]"
                >
                  09183119682
                </a>
              </div>

              <div className="flex items-center gap-2">
                <FiMail className="h-4 w-4 shrink-0 text-[#FFC107]" />
                <a
                  href="mailto:info@sazin-co.ir"
                  className="transition-colors hover:text-[#FFC107]"
                >
                  info@sazin-co.ir
                </a>
              </div>
            </div>

            <Link
              to="/contact-us"
              className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-[#FFC107] transition-colors hover:text-[#D19D00]"
            >
              تماس با ما
              <span aria-hidden="true">←</span>
            </Link>
          </div>

          {/* Quick links */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-4 shadow-sm sm:p-5">
            <h3 className="mb-4 text-base font-semibold text-white">
              دسترسی سریع
            </h3>

            <div className="space-y-3 text-sm">
              <Link
                to="/about-us"
                className="block text-white/80 transition-colors hover:text-[#FFC107]"
              >
                درباره ما
              </Link>
              <Link
                to="/contact-us"
                className="block text-white/80 transition-colors hover:text-[#FFC107]"
              >
                تماس با ما
              </Link>
              <Link
                to="/"
                className="block text-white/80 transition-colors hover:text-[#FFC107]"
              >
                فروشگاه
              </Link>
              <Link
                to="/cart/"
                className="block text-white/80 transition-colors hover:text-[#FFC107]"
              >
                سبد خرید
              </Link>
              <Link
                to="/faq/"
                className="block text-white/80 transition-colors hover:text-[#FFC107]"
              >
                سوالات متداول
              </Link>
            </div>
          </div>

          {/* Company info */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-4 shadow-sm sm:p-5">
            <h3 className="mb-4 text-base font-semibold text-white">
              اطلاعات شرکت
            </h3>

            <p className="text-sm leading-7 text-white/80 text-justify">
              ما با تکیه بر شبکه تأمین‌کنندگان معتبر و تیم پشتیبانی پاسخ‌گو،
              تلاش می‌کنیم فرایند انتخاب و خرید مصالح ساختمانی را برای شما
              ساده‌تر، سریع‌تر و قابل اعتمادتر کنیم.
            </p>

            <div className="mt-4 rounded-lg bg-white/10 px-3 py-2 text-xs leading-6 text-white/75 text-justify">
             همدان، کیلومتر 5 جاده کرمانشاه، روبه روی کارخانه آرد مریانج، فروشگاه کالای ساختمانی سازین.
              <br />
              تلفن همراه: 09183119682
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 border-t border-white/10 pt-4">
          <div className="flex flex-col items-center justify-between gap-3 text-center md:flex-row md:text-right">
            <p className="text-xs leading-6 text-white/70 sm:text-sm">
              تمامی حقوق این وب‌سایت متعلق به شرکت ما است و هرگونه کپی‌برداری
              بدون اجازه ممنوع می‌باشد.
            </p>

            <p className="text-xs font-medium text-[#FFC107] sm:text-sm">
              © {new Date().getFullYear()} Sazin-co.ir
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
